import type { ImportDraftIngredient } from '@fewerbags/schema';

type Confidence = ImportDraftIngredient['confidence'];

const STYLES: Record<Confidence, string> = {
  high: 'bg-accent-soft text-accent-ink',
  medium: 'bg-orange-soft text-orange-ink',
  low: 'bg-red-50 text-fail',
};

const WORDS: Record<Confidence, string> = {
  high: 'Parsed cleanly',
  medium: 'Check this line',
  low: 'Needs attention',
};

/** How sure the importer was about one parsed line. Colour is backed up by the word. */
export function ConfidenceBadge({ confidence }: { confidence: Confidence }) {
  return (
    <span
      className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ${STYLES[confidence]}`}
    >
      {WORDS[confidence]}
    </span>
  );
}
